import React from 'react';
import '../../CustomModule.css';
import CommonAction from './CommonAction';
import { imageUrl } from '../../../../../Components/helper';

export function CompanyStamp({
  companyLogo,
  label,
  fromForm,
  duplicatingItem,
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const filePreview = () => {
    return companyLogo ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${companyLogo}`) : '';
  };
  let logo = null;
  if (companyLogo.includes('base64')) {
    logo = companyLogo;
  } else {
    logo = `${imageUrl}/${companyLogo}`;
  }

  return (
    <div className="text-center">
      <p className={`text-left mb-1 fs-custom-module ${boldLabel && 'font-weight-bold'}`}>{label}</p>
      {companyLogo !== '' && <img src={companyLogo.includes('base64') ? logo : filePreview()} className="company-stamp" alt="" />}

      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}
export default CompanyStamp;
